<template>
  <div
    id="error"
    :class="luigiClasses"
  >
    <HeaderInheritedArea />
    <div
      class="mx-auto my-10 text-neutral-900 md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl mobile:m-3"
    >
      <div
        v-if="error.statusCode !== 404"
        class="flex flex-col items-center gap-5 text-center"
      >
        <NuxtImg
          :src="'/img/error/error.svg'"
          alt="leaves"
          title="leaves"
          width="240px"
        />
        <KikHeading
          title="An error occured"
          description="Please go back or try again"
        />
        <NuxtLink
          class="text-primary-700 underline"
          to="/"
        >
          {{ $t("Back to homepage") }}
        </NuxtLink>
        <KikButton
          variant="primary"
          @click="$router.back()"
        >
          {{ $t("Go back") }}
        </KikButton>
      </div>
      <div
        v-else-if="errorContent?.area1?.[0]?.content"
        v-html="errorContent?.area1?.[0]?.content"
      />
      <div
        v-else
        class="relative mb-md rounded border border-warning-400 bg-warning-100 px-4 py-3 text-warning-700"
      >
        {{ $t('somethingWentWrong') }}
      </div>
    </div>
    <InheritedPreFooterArea />
    <FooterInheritedArea />
  </div>
</template>

<script lang="ts" setup>
import type { NuxtError } from '#app';
import { useUser } from '~/composables/custom/useUser/useUser';
import { usePageLoader } from '~/composables/custom/usePageLoader/usePageLoader';
import { useLuigisbox } from '~/composables/useLuigisbox';
import config from '~/magnolia/magnolia.config';
import InheritedPreFooterArea from '~/components/Footer/PreFooter/InheritedArea.vue';
import { useSSR } from '~/composables/useSSR/useSSR';
import { useWindow } from '~/composables/useWindow';

interface Props {
  error: NuxtError;
}

const props = defineProps<Props>();
const { classes: luigiClasses } = useLuigisbox();
const { errorContent, getErrorContent } = usePageLoader('404-error-page');

const { load: loadCategories, result: categories } = useCategories();
const { load } = useUser();
const { onSSR } = useSSR();
const { setContentPageInfo, setSeoTitle } = useSeo();

useWindow();

provide('config', config);
provide('templateAnnotations', {});
provide('content', {});

onSSR(async () => {
  if (!categories.value?.length) {
    await loadCategories();
  }

  if (props.error.statusCode === 404 && !errorContent.value) {
    await getErrorContent();
    setSeoTitle('404 | KiK online shop');
  }
  else {
    setContentPageInfo(errorContent);
  }
});

onBeforeMount(async () => {
  await load();
});

// onMounted(init);
</script>
